import { CSSProperties } from 'react';
import { FelaCSSWithCustomSelectors, TColor, colors } from '@bridebook/ui/src/index';

interface IProps {
  width?: number;
  starGap: number;
}

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
  reviewIcon: (overrideColor?: TColor) => CSSProperties;
  reviewFilledIcon: (overrideColor?: TColor) => CSSProperties;
}

const styles = ({ width, starGap }: IProps): IStyles => ({
  wrapper: {
    flexShrink: 0,

    '> span': {
      display: 'flex !important',
      justifyContent: 'flex-start',

      '> span': {
        ':not(:last-of-type)': {
          marginRight: `${starGap}px`,
        },
      },
    },
  },
  reviewIcon: (overrideColor?: TColor) => ({
    color: overrideColor ? colors[overrideColor] : colors.space30,
    fontSize: width,
  }),
  reviewFilledIcon: (overrideColor?: TColor) => ({
    color: overrideColor ? colors[overrideColor] : colors.peachRose120,
    fontSize: width,
  }),
});

export default styles;
